import { noop } from 'rxjs';
import { Directive } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: 'input[trim]',
    providers: [NgModel],
    host: {
        '(ngModelChange)': 'onInputChange($event)',
        '(blur)': 'onBlur()'
    },
    standalone: false
})

export class TrimValueAccessor {
    onChange = noop;

    private el: NgModel;
    private newValue: string;

    constructor(private model: NgModel) {
        this.el = model;
    }
    
    onInputChange(event) {
        this.newValue = event;
    }
    
    onBlur() {
        if (this.newValue) {
            this.model.control.setValue(this.newValue.trim());
        }
    }
}